import type { ExerciseMcq } from "~/features/computer/data/exercises/exercise.types";

export const mcqLinks: Record<string, string> = {
  var1: "/11th/computer/python/notes/",
  var2: "/11th/computer/python/notes/",
  io1: "/11th/computer/python/notes/",
  io2: "/11th/computer/python/notes/",
  op1: "/11th/computer/python/notes/",
  op2: "/11th/computer/python/notes/",
  op3: "/11th/computer/python/notes/",
  if1: "/11th/computer/python/notes/",
  if2: "/11th/computer/python/notes/",
  loop1: "/11th/computer/python/notes/",
  loop2: "/11th/computer/python/notes/",
  fn1: "/11th/computer/python/long-questions/",
  fn2: "/11th/computer/python/long-questions/",
  list1: "/11th/computer/data-structures/",
  list2: "/11th/computer/data-structures/",
  ds1: "/11th/computer/data-structures/",
  ds2: "/11th/computer/data-structures/",
  ds3: "/11th/computer/data-structures/",
  ds4: "/11th/computer/data-structures/",
  ds5: "/11th/computer/data-structures/",
  ds6: "/11th/computer/data-structures/",
  et1: "/11th/computer/emerging-tech/",
  et2: "/11th/computer/emerging-tech/",
  et3: "/11th/computer/emerging-tech/",
  et4: "/11th/computer/emerging-tech/",
  et5: "/11th/computer/emerging-tech/",
  et6: "/11th/computer/emerging-tech/",
  et7: "/11th/computer/emerging-tech/",
  et8: "/11th/computer/emerging-tech/",
  et9: "/11th/computer/emerging-tech/",
};

const topicBaseRoutes: Record<string, string> = {
  bias: "/11th/computer/legal-ethics/",
  "cloud-models": "/11th/computer/emerging-tech/",
  "digital-citizenship": "/11th/computer/legal-ethics/",
  "digital-divide": "/11th/computer/legal-ethics/",
  "digital-literacy": "/11th/computer/digital-literacy/",
  evaluation: "/11th/computer/digital-literacy/",
  boolean: "/11th/computer/digital-literacy/",
  search: "/11th/computer/digital-literacy/",
  "online-libraries": "/11th/computer/digital-literacy/",
  "intellectual-property": "/11th/computer/digital-literacy/",
  entrepreneurship: "/11th/computer/entrepreneurship/",
  "design-thinking": "/11th/computer/entrepreneurship/",
  "business-plan": "/11th/computer/entrepreneurship/",
  "market-research": "/11th/computer/entrepreneurship/",
  marketing: "/11th/computer/entrepreneurship/",
  finance: "/11th/computer/entrepreneurship/",
  pitch: "/11th/computer/entrepreneurship/",
  "security-threats": "/11th/computer/legal-ethics/",
  terms: "/11th/computer/legal-ethics/",
};

export function getMcqConceptLink(questionOrId: string | ExerciseMcq) {
  if (typeof questionOrId !== "string") {
    if (questionOrId.topic) {
      const base = topicBaseRoutes[questionOrId.topic];

      if (base) {
        return base;
      }
    }

    return mcqLinks[questionOrId.id] ?? null;
  }

  return mcqLinks[questionOrId] ?? null;
}
